module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABDElEQVRYR+2XIU6DQRCFvydIcCgQFYRAVYvrAXoDBCeoIzg0ioraKnSLqGpFVUmqSu9ACIoEDwINyZAl24QQ+u8SNqmZNSvm7c7LlxHzRMUxsxZwCOwCe1Xa3Jqkq+9a/fbQzBrABdABXoDXeOf2WadbJg3E5mPgHriU9PTfruG9mS2ALAN9oC7ppETj1R9/MTADJpJuNmUgoOpKunMDTsAJOAEn4AScgBNwAmZ2VJDCCJjnbMVfKxnwADwD2wkT77G+ldB9AL1sA74TAk3gOoH17Ud9J6GfSjqtjGYxQDxKOjez44JDOABuc2Yg5MEhEIJJGMJSp50VzWKOOwDOgH2gVspBtoGCDZNffQLC7CIwQpVtTgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left/journal0.png
// module id = CVqi
// module chunks = 3